import { format } from 'date-fns';
export const formatDateToISODays = (input) => {
    const date = new Date(input);
    return format(date, 'yyyy-MM-dd');
};
export const formatDateToDays = (input) => {
    const date = new Date(input);
    return format(date, 'dd. MM. yyyy');
};
export const formatDateToMinutes = (input) => {
    const date = new Date(input);
    return format(date, 'dd. MM. yyyy, HH:mm');
};
export const formatDateToSeconds = (input) => {
    const date = new Date(input);
    return format(date, 'dd. MM. yyyy HH:mm:ss');
};
export const formatDateToHoursAndMinutes = (input) => {
    const date = new Date(input);
    return format(date, 'HH:mm');
};
